import GaLogger from './GaLogger';

class MgmLogger extends GaLogger {
  getContentRenderedPayload(response) {
    const {
      adResultsDisplayedTop,
      adResultsDisplayedBottom,
      adResultsDisplayed,
      eventType,
    } = response;
    const { pageParams } = this.adInstance;

    return {
      event: 'ad-content-rendered',
      ad_resultsDisplayedTop: adResultsDisplayedTop,
      ad_resultsDisplayedBottom: adResultsDisplayedBottom,
      ad_resultsDisplayed: adResultsDisplayed,
      eventDate: new Date().toISOString(),
      eventType,
      oCode: pageParams.o,
    };
  }

  getClickPayload(index, keyword, lpUrl, isFirstAdBlock) {
    return {
      event: 'ad-click',
      eventType: 'Action-Click',
      eventDate: new Date().toISOString(),
      zone: isFirstAdBlock ? 'top' : 'bottom',
    };
  }
}

export default MgmLogger;
